/**
 * Valida si una oferta sigue vigente según la fecha en la URL
 * Regla:
 * - Fecha única: hoy < fecha
 * - Rango: hoy < fecha inicio
 */
export const isOfferValid = (urlDate: string): boolean => {
  if (!urlDate) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Rango de fechas: YYYY-MM-DD/YYYY-MM-DD
  if (urlDate.includes("/")) {
    const [startDate] = urlDate.split("/");
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    return today < start;
  }

  // Fecha única: YYYY-MM-DD
  const date = new Date(urlDate);
  date.setHours(0, 0, 0, 0);

  return today < date;
};
